<!-- Modal backdrop con animación de fade -->
@if (notificationEstablishmentService.isOpen$ | async) {
  <div
    class="fixed inset-0 bg-black/40 z-[9999] flex items-center justify-center transition-opacity duration-300 ease-in-out overflow-y-auto py-10"
    click="closeModal()"
    >
    <!-- Contenedor del modal con animación de entrada -->
    <div
      class="bg-white rounded-lg shadow-md w-11/12 sm:w-10/12 md:w-9/12 lg:w-8/12 max-w-md mx-auto z-50 overflow-hidden transform transition-all duration-300 ease-in-out"
      (click)="$event.stopPropagation()"
      >
      <!-- Cabecera del modal -->
      <div
      [ngClass]="{
        'bg-amber-400': !(notificationEstablishmentService.isRejected$ | async),
        'bg-red-500': (notificationEstablishmentService.isRejected$ | async)
      }"
        class="px-4 sm:px-6 py-3 sm:py-4 border-b flex justify-between items-center"
      [ngClass]="{
        'border-amber-300': !(
          notificationEstablishmentService.isRejected$ | async
        ),
        'border-red-400': (notificationEstablishmentService.isRejected$ | async)
      }"
        >
        <h3 class="text-base sm:text-lg font-medium text-black">
          @if (!(notificationEstablishmentService.isRejected$ | async)) {
            Esperando Respuesta
          }
          @if (notificationEstablishmentService.isRejected$ | async) {
            Pedido Rechazado
          }
        </h3>
      </div>
      <!-- Cuerpo del modal -->
      <div class="p-6 flex flex-col items-center justify-center">
        <!-- Contenido cuando está esperando respuesta -->
        @if (!(notificationEstablishmentService.isRejected$ | async)) {
          <figure>
            <img
              src="assets/animations/gif-espera-540px.gif"
              width="100"
              alt=""
              />
            </figure>
            <!-- Texto informativo -->
            <p class="text-center text-gray-700 mb-4">
              El establecimiento está revisando tu pedido. Esto puede tomar unos
              minutos.
            </p>
            <!-- Icono y texto de notificación -->
            <div class="flex items-center text-amber-500 mb-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
                <span>Notificando al establecimiento</span>
              </div>
              <!-- Tiempo estimado -->
              <div class="flex items-center text-gray-600">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span>Tiempo estimado: 2-10 minutos</span>
                </div>
                <!-- Teléfono del establecimiento -->
                <div class="flex items-center text-gray-600 mt-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                      />
                    </svg>
                    <span
                      >Número de establecimiento: <a href="tel:{{ phone }}">{{ phone }}</a>
                    </span>
                  </div>
                  <!-- Indicadores de carga (puntos) -->
                  <div class="flex justify-center space-x-2 mt-6">
                    <div class="h-2 w-2 bg-amber-400 rounded-full"></div>
                    <div class="h-2 w-2 bg-amber-300 rounded-full"></div>
                    <div class="h-2 w-2 bg-amber-200 rounded-full"></div>
                  </div>
                }
                <!-- Contenido cuando el pedido es rechazado -->
                @if (notificationEstablishmentService.isRejected$ | async) {
                  <!-- Icono de rechazo -->
                  <div class="flex justify-center items-center mb-4">
                    <div
                      class="rounded-full h-16 w-16 bg-red-100 flex items-center justify-center"
                      >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-10 w-10 text-red-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </div>
                    </div>
                    <!-- Texto informativo de rechazo -->
                    <p class="text-center text-gray-700 mb-4 font-medium">
                      Pedido Rechazado por el Establecimiento
                    </p>
                    <p class="text-center text-gray-600 mb-4">
                      Lo sentimos, el establecimiento no ha podido aceptar tu pedido en este
                      momento.
                    </p>
                    <!-- Botón para cerrar -->
                    <button
                      (click)="closeModal()"
                      class="mt-4 px-6 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors duration-300"
                      >
                      Cerrar
                    </button>
                  }
                </div>
              </div>
            </div>
          }
